import type { Plugin } from 'vue';
import * as am5 from '@amcharts/amcharts5';

export const amchartsPlugin: Plugin = {
  install() {
    if (import.meta.env.VITE_AMCHARTS_LICENSE_KEY) {
      am5.addLicense(import.meta.env.VITE_AMCHARTS_LICENSE_KEY);
    }
  },
};
